import light from './light-theme'
import dark from './dark-theme'

export default {
  light,
  dark
}
